import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ManageEntityTagsDialogComponent, ManageEntityTagsDialogParams } from './manage-entity-tags-dialog.component'

@Injectable()
export class ManageEntityTagsDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: ManageEntityTagsDialogParams) {
    const config: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      data,
    }

    return this.dialog.open(ManageEntityTagsDialogComponent, config)
  }
}
